import React, { useState, useEffect, useContext } from "react";
import SubscriptionServiceTable from "./IPTVAccountTable";
import Modal from "react-bootstrap/Modal";
import AddIPTV from "./IPTVAccountAdd";
import AddIPTVSub from "./IPTVSubAdd"
import AuthContext from "../context/AuthContext";
import axios from "axios";
import { API_URL } from "../components/api";

function IPTVAccount() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);
  const [showSub, setShowSub] = useState(false);
  const handleCloseSub = () => setShowSub(false);

  const handleShowSub = () => setShowSub(true);

  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [user.username]);
  return (
    <div className="Plans">
      <div className="main">
        <div>
          <button onClick={handleShow} className="AddClient">
            Add IPTV Account
          </button>
        </div>
        <SubscriptionServiceTable />
      </div>
      <Modal show={show} onHide={handleClose}>
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>Add Account</Modal.Title>
          </Modal.Header>
          <AddIPTV />
        </div>
      </Modal>
      <Modal show={showSub} onHide={handleCloseSub}>
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>Add IPTV Subscription</Modal.Title>
          </Modal.Header>
          <AddIPTVSub />
        </div>
      </Modal>
    </div>
  );
}

export default IPTVAccount;
